import Vue from 'vue'
import router from '../../router'
import store from '../../store'
import _ from 'lodash'

let modals = {
}
let initVueComponentInModals = key => {
  modals[key] = Vue.extend({
    components: { Modal: modals[key] },
    template: '<Modal/>',
    router,
    store
  })
}
for (let key in modals) {
  if (modals.hasOwnProperty(key)) {
    initVueComponentInModals(key)
  }
}

// 注册Modal组件
const registerModal = (name, ModalComponent) => {
  modals[name] = ModalComponent
  initVueComponentInModals(name)
}

export { registerModal }

export default {
  registerModal,
  install(Vue) {
    // 第一个参数：名称，其它参数：传入init方法的参数
    // 返回一个对象，包含modal引用以及promise对象{ref, promise}
    Vue.prototype.modal = function () {
      let name
      let otherArgs = []
      for (let arg of arguments) {
        if (name) {
          otherArgs.push(arg)
        } else {
          name = arg
        }
      }
      if (!name || !modals[name]) throw new Error('modal invoke error')
      let Component = modals[name]
      let vm = new Component()
      vm.$mount()
      document.body.appendChild(vm.$el)
      let modal = vm.$children[0]
      if (!modal.init || !_.isFunction(modal.init)) {
        document.body.removeChild(vm.$el)
        throw new Error('[init] method of Modal component is needed')
      }
      let promise = modal.init.apply(modal, otherArgs)
      if (promise) {
        return { ref: modal, promise }
      } else {
        document.body.removeChild(vm.$el)
        vm.$destroy()
        return null
      }
    }
  }
}
